import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { orderReviewsAPI } from '../../services/api';

const styles = `
  @media print {
    @page { size: A4; margin: 10mm; }
    body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    .no-print { display: none !important; }
    .page-break { page-break-before: always; }
    table, tr, td, th { page-break-inside: avoid; }
  }
  .orf { font-family: 'Segoe UI', Tahoma, sans-serif; max-width: 210mm; margin: 0 auto; padding: 10mm; background: #fff; color: #111; font-size: 10px; }
  .orf h1 { font-size: 14px; margin: 0; letter-spacing: .4px; }
  .orf h2 { font-size: 11px; margin: 14px 0 5px; text-transform: uppercase; background: #e8edf5; padding: 4px 6px; border-left: 3px solid #1e40af; }
  .orf h3 { font-size: 10px; margin: 10px 0 4px; text-transform: uppercase; color: #1e3a8a; }
  .orf .hint { font-size: 8.5px; color: #555; font-style: italic; margin: 2px 0 5px; }
  .hdr { display: flex; gap: 10px; align-items: flex-start; border-bottom: 2px solid #1e40af; padding-bottom: 6px; }
  .hdr img { width: 46px; height: 46px; object-fit: contain; }
  .hdr .co { flex: 1; }
  .hdr .co p { margin: 1px 0; font-size: 8.5px; color: #333; }
  .hdr .co .certs { color: #047857; font-size: 8px; }
  .docbox { border: 1px solid #94a3b8; font-size: 8.5px; min-width: 120px; }
  .docbox div { display: flex; border-bottom: 1px solid #cbd5e1; }
  .docbox div:last-child { border-bottom: 0; }
  .docbox span { padding: 2px 4px; }
  .docbox span:first-child { width: 48px; color: #475569; border-right: 1px solid #cbd5e1; }
  .title { text-align: center; margin: 8px 0 2px; }
  .title p { margin: 2px 0 0; font-size: 8.5px; color: #444; }
  table { width: 100%; border-collapse: collapse; }
  .kv td { border: 1px solid #94a3b8; padding: 3px 5px; vertical-align: top; }
  .kv td.k { background: #f1f5f9; color: #334155; width: 15%; font-size: 8.5px; text-transform: uppercase; letter-spacing: .3px; }
  .grid th, .grid td { border: 1px solid #94a3b8; padding: 3px 4px; text-align: left; vertical-align: top; }
  .grid th { background: #1e40af; color: #fff; font-size: 8.5px; text-transform: uppercase; }
  .grid td { height: 15px; }
  .mono { font-family: Consolas, monospace; }
  .mark { font-size: 10px; letter-spacing: 1px; }
  .sign td { border: 1px solid #94a3b8; padding: 5px; height: 28px; }
  .sign th { border: 1px solid #94a3b8; background: #f1f5f9; padding: 3px 4px; font-size: 8.5px; text-transform: uppercase; }
  .foot { margin-top: 10px; border-top: 1px solid #cbd5e1; padding-top: 4px; font-size: 7.5px; color: #64748b; display: flex; justify-content: space-between; }
  .btn { position: fixed; top: 16px; right: 16px; background: #1e40af; color: #fff; border: 0; padding: 10px 18px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer; }
  .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; font-family: sans-serif; }
`;

const date = (value) => (value ? new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '');
const box = (checked) => (checked ? '\u2612' : '\u2610');
const mark = (status, value) => `${box(status === value)} ${value === 'na' ? 'N/A' : value.charAt(0).toUpperCase() + value.slice(1)}`;

const Header = ({ sheet, page, pages }) => (
  <>
    <div className="hdr">
      <img src="/logo.png" alt="" onError={(event) => { event.target.style.display = 'none'; }} />
      <div className="co">
        <h1>SINGHANIA INTERNATIONAL LIMITED</h1>
        <p>Cold-Forged Fasteners &nbsp;STURDFIX&trade; | SFX&trade;</p>
        <p>C-25, Phase-1, Focal Point, Dhandari Kalan, Ludhiana - 141010, Punjab, India</p>
        <p className="certs">IATF 16949 &middot; ISO 9001 &middot; ISO 14001 &middot; ISO 45001 &middot; AEO / C-TPAT</p>
      </div>
      <div className="docbox">
        <div><span>Doc. No.</span><span>{sheet.doc_no}</span></div>
        <div><span>Rev./Date</span><span>{sheet.doc_rev} / {date(sheet.created_at)}</span></div>
        <div><span>Issued by</span><span>Marketing</span></div>
        <div><span>Page</span><span>{page} of {pages}</span></div>
      </div>
    </div>
    <div className="title">
      <h2 style={{ background: 'none', borderLeft: 0, margin: '6px 0 0', fontSize: '12px' }}>ORDER REVIEW &amp; FEASIBILITY SHEET</h2>
      <p>Contract review as per IATF 16949 cl. 8.2.3 — to be completed before confirmation of every Order Acceptance</p>
      <p className="mono">Review Sheet No.: {sheet.review_sheet_no}</p>
    </div>
  </>
);

const Footer = ({ page, pages }) => (
  <div className="foot">
    <span>F-MKT-04 Rev 00 | Order Review &amp; Feasibility Sheet | Singhania International Limited</span>
    <span>Controlled document - uncontrolled when printed | Page {page} of {pages}</span>
  </div>
);

const Checklist = ({ items }) => (
  <table className="grid">
    <thead>
      <tr><th style={{ width: '4%' }}>#</th><th>Review point</th><th style={{ width: '20%' }}>Status</th><th style={{ width: '26%' }}>Remarks / action</th></tr>
    </thead>
    <tbody>
      {items.map((item, index) => (
        <tr key={item.id}>
          <td>{index + 1}</td>
          <td>{item.point}</td>
          <td className="mark">{mark(item.status, 'yes')} {mark(item.status, 'no')} {mark(item.status, 'na')}</td>
          <td>{item.remarks || ''}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

const PartSheet = ({ part, index, total, sheet, page, pages }) => {
  const id = part.identification || {};
  const packing = part.packing || {};
  return (
    <div className="page-break">
      <Header sheet={sheet} page={page} pages={pages} />
      <h2>Part review sheet — part {index + 1} of {total} &nbsp;|&nbsp; Part sheet no. {part.part_sheet_no}</h2>

      <h3>A. Part identification</h3>
      <table className="kv">
        <tbody>
          <tr><td className="k">Customer part no.</td><td>{id.customer_part_no}</td><td className="k">SIL part / item code</td><td className="mono">{id.sil_part_code}</td><td className="k">Part status</td><td>{(id.part_status || '').replace(/_/g, ' ')}</td></tr>
          <tr><td className="k">Description</td><td colSpan={3}>{id.description}</td><td className="k">Material / grade</td><td>{id.material_grade}</td></tr>
          <tr><td className="k">Size / thread</td><td>{id.size_thread}</td><td className="k">Surface finish</td><td>{id.surface_finish}</td><td className="k">Drawing no. / rev.</td><td>{id.drawing_rev}</td></tr>
          <tr><td className="k">Order qty</td><td>{id.order_qty}</td><td className="k">Qty in finished stock</td><td>{id.qty_in_stock}</td><td className="k">Qty to produce</td><td>{id.qty_to_produce}</td></tr>
          <tr><td className="k">Customer delivery date</td><td>{date(id.delivery_date)}</td><td className="k">PPAP / sample</td><td>{id.ppap_required ? `${id.ppap_required}${id.ppap_level ? ` — ${id.ppap_level}` : ''}` : ''}</td><td className="k">Part feasible?</td><td>{(part.feasible || '').replace(/_/g, ' ')}</td></tr>
        </tbody>
      </table>

      <h3>B. Raw material</h3>
      <p className="hint">Stores / Purchase - if not in stock, enter expected receipt date</p>
      <table className="grid">
        <thead>
          <tr><th>RM spec. / grade</th><th>Wire dia. / size</th><th>Qty reqd. (kg)</th><th>In stock? (Y/N, kg)</th><th>If No - PO placed / expected date</th><th>RM processing by</th><th>Processing date</th></tr>
        </thead>
        <tbody>
          {(part.raw_material || []).map((row) => (
            <tr key={row.id}><td>{row.rm_spec}</td><td>{row.wire_dia}</td><td>{row.qty_kg}</td><td>{row.in_stock}</td><td>{row.po_or_expected}</td><td>{row.processing_by}</td><td>{date(row.processing_date)}</td></tr>
          ))}
        </tbody>
      </table>

      <h3>C. Tooling <span style={{ fontWeight: 400, textTransform: 'none' }}>— Tool Room</span></h3>
      <table className="grid">
        <thead>
          <tr><th>Tool / die description</th><th>Tool no.</th><th>Available? (Y/N)</th><th>New tool reqd.? (Y/N)</th><th>Tool ready by</th><th>Remarks</th></tr>
        </thead>
        <tbody>
          {(part.tooling || []).map((row) => (
            <tr key={row.id}><td>{row.description}</td><td>{row.tool_no}</td><td>{row.available}</td><td>{row.new_required}</td><td>{date(row.ready_by)}</td><td>{row.remarks}</td></tr>
          ))}
        </tbody>
      </table>

      <h3>D. Process routing — H&amp;T, surface finish &amp; other operations <span style={{ fontWeight: 400, textTransform: 'none' }}>— Production / PPC</span></h3>
      <table className="grid">
        <thead><tr><th style={{ width: '24%' }}>Process step</th><th style={{ width: '20%' }}>Where / how</th><th style={{ width: '18%' }}>Vendor / machine</th><th style={{ width: '13%' }}>Planned date</th><th>Remarks</th></tr></thead>
        <tbody>
          {(part.routing || []).map((row) => (
            <tr key={row.id}>
              <td>{row.step}</td>
              <td className="mark">{box(row.where === 'in_house')} In-house &nbsp;{box(row.where === 'outsourced')} Outsourced &nbsp;{box(row.where === 'na')} N/A</td>
              <td>{row.vendor_machine}</td><td>{date(row.planned_date)}</td><td>{row.remarks}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>E. Packing specification &amp; packaging material</h3>
      <table className="kv">
        <tbody>
          <tr>
            <td className="k">Packing spec.</td>
            <td colSpan={3} className="mark">
              {box(packing.spec_choice === 'customer')} Customer spec received {packing.spec_ref ? `(ref: ${packing.spec_ref})` : '(ref: ________)'} &nbsp;
              {box(packing.spec_choice === 'sil_standard')} SIL standard &nbsp;
              {box(packing.spec_choice === 'not_received')} Not received &nbsp;
              {box(packing.spec_choice === 'to_clarify')} To be clarified
            </td>
          </tr>
          <tr><td className="k">Qty / wt per inner</td><td>{packing.qty_per_inner}</td><td className="k">Qty / wt per carton</td><td>{packing.qty_per_carton}</td></tr>
          <tr>
            <td className="k">Pallet</td>
            <td className="mark">{box(packing.pallet_type === 'wood')} Wood (ISPM-15) &nbsp;{box(packing.pallet_type === 'plastic')} Plastic</td>
            <td className="k">Pallet size</td><td>{packing.pallet_size}</td>
          </tr>
          <tr><td className="k">Labelling</td><td colSpan={3} className="mark">
            {['Customer label', 'SIL label', 'Barcode / EDI', 'Country of origin'].map((option) => (
              <span key={option}>{box((packing.labelling || []).includes(option))} {option} &nbsp;</span>
            ))}
          </td></tr>
          <tr><td className="k">Protection</td><td colSpan={3} className="mark">
            {['VCI / oil', 'Poly bag', 'Desiccant', 'None'].map((option) => (
              <span key={option}>{box((packing.protection || []).includes(option))} {option} &nbsp;</span>
            ))}
          </td></tr>
          <tr><td className="k">Special / regulatory</td><td colSpan={3} className="mark">
            {['PPWR', 'Recyclable only', 'Returnable packaging'].map((option) => (
              <span key={option}>{box((packing.special || []).includes(option))} {option} &nbsp;</span>
            ))}
            {box(Boolean(packing.special_other))} Other: {packing.special_other || '____________'}
          </td></tr>
        </tbody>
      </table>
      <table className="grid" style={{ marginTop: '4px' }}>
        <thead><tr><th>Packaging material</th><th>Spec. / size</th><th>Qty reqd.</th><th>In stock? (Y/N)</th><th>If No - expected date</th><th>Remarks / vendor</th></tr></thead>
        <tbody>
          {(packing.materials || []).map((row) => (
            <tr key={row.id}><td>{row.material}</td><td>{row.spec}</td><td>{row.qty}</td><td>{row.in_stock}</td><td>{date(row.expected_date)}</td><td>{row.remarks}</td></tr>
          ))}
        </tbody>
      </table>

      <h3>F. Technical feasibility</h3>
      <p className="hint">Quality / Production - any &quot;No&quot; requires a remark</p>
      <Checklist items={part.technical_review || []} />

      <h3>G. Part schedule &amp; result</h3>
      <table className="kv">
        <tbody>
          <tr>
            <td className="k">Planned production start</td><td>{date(part.schedule?.production_start)}</td>
            <td className="k">Planned completion</td><td>{date(part.schedule?.completion)}</td>
            <td className="k">Planned dispatch</td><td>{date(part.schedule?.dispatch)}</td>
          </tr>
          <tr><td className="k">Conditions / deviations / remarks</td><td colSpan={5}>{part.conditions_remarks}</td></tr>
        </tbody>
      </table>

      <table className="sign" style={{ marginTop: '6px' }}>
        <thead><tr><th style={{ width: '26%' }}>Reviewed by</th><th style={{ width: '30%' }}>Function</th><th>Signature</th><th style={{ width: '16%' }}>Date</th></tr></thead>
        <tbody>
          {['Stores / Purchase (RM & packaging)', 'Tool Room', 'Production / PPC', 'Quality Assurance'].map((function_) => (
            <tr key={function_}><td /><td>{function_}</td><td /><td /></tr>
          ))}
        </tbody>
      </table>
      <Footer page={page} pages={pages} />
    </div>
  );
};

export default function OrderReviewSheetPrintView() {
  const { id } = useParams();
  const [sheet, setSheet] = useState(null);
  const [printTriggered, setPrintTriggered] = useState(false);
  const isPreview = new URLSearchParams(window.location.search).get('preview') === 'true';

  useEffect(() => {
    orderReviewsAPI.get(id).then((response) => setSheet(response.data));
    if (!isPreview) orderReviewsAPI.markDownloaded(id).catch(() => {});
  }, [id, isPreview]);

  useEffect(() => {
    if (sheet && !printTriggered && !isPreview) {
      setPrintTriggered(true);
      const timer = setTimeout(() => window.print(), 700);
      return () => clearTimeout(timer);
    }
  }, [sheet, printTriggered, isPreview]);

  if (!sheet) {
    return <div className="loading" data-testid="order-review-print-loading"><style>{styles}</style>Loading sheet…</div>;
  }

  const details = sheet.order_details || {};
  const parts = sheet.parts || [];
  const pages = 2 + parts.length;

  return (
    <div className="orf" data-testid="order-review-print-view">
      <style>{styles}</style>
      {!isPreview && (
        <button className="btn no-print" onClick={() => window.print()} data-testid="order-review-print-again">Print / Save PDF</button>
      )}

      <Header sheet={sheet} page={1} pages={pages} />

      <h2>1. Order details</h2>
      <table className="kv">
        <tbody>
          <tr><td className="k">Customer</td><td>{details.customer}</td><td className="k">Customer PO no.</td><td className="mono">{details.customer_po_no}</td><td className="k">PO date</td><td>{date(details.po_date)}</td></tr>
          <tr><td className="k">Order acceptance no.</td><td className="mono">{details.order_acceptance_no}</td><td className="k">OA date</td><td>{date(details.oa_date)}</td><td className="k">Quotation ref.</td><td className="mono">{details.quotation_reference}</td></tr>
          <tr>
            <td className="k">Order type</td>
            <td className="mark">{box(details.order_type === 'new')} New &nbsp;{box(details.order_type === 'repeat')} Repeat &nbsp;{box(details.order_type === 'modified')} Modified (eng. change)</td>
            <td className="k">Customer delivery date</td><td>{date(details.customer_delivery_date)}</td>
            <td className="k">Order value</td><td>{details.order_value ? `${details.currency || ''} ${Number(details.order_value).toLocaleString('en-IN')}` : ''}</td>
          </tr>
          <tr>
            <td className="k">PPAP / sample required</td>
            <td className="mark">{box(details.ppap_required === 'yes')} Yes {details.ppap_level ? `(${details.ppap_level})` : '(level: ______)'} &nbsp;{box(details.ppap_required === 'no')} No</td>
            <td className="k">Incoterm / destination</td><td>{details.incoterm_destination}</td>
            <td className="k">Drawing / spec. rev.</td><td>{details.drawing_spec_rev}</td>
          </tr>
          <tr><td className="k">Customer-specific reqts (CSR) ref.</td><td colSpan={5}>{details.csr_ref}</td></tr>
        </tbody>
      </table>

      <h2>2. Parts on this order</h2>
      <p className="hint">One Part Review Sheet to be completed for each line</p>
      <table className="grid">
        <thead>
          <tr><th style={{ width: '4%' }}>#</th><th>Part no. / description</th><th style={{ width: '11%' }}>Size</th><th style={{ width: '13%' }}>Material / grade</th><th style={{ width: '9%' }}>Order qty</th><th style={{ width: '13%' }}>Cust. delivery date</th><th style={{ width: '13%' }}>Part sheet no.</th><th style={{ width: '8%' }}>Feasible?</th></tr>
        </thead>
        <tbody>
          {parts.map((part, index) => (
            <tr key={part.id}>
              <td>{index + 1}</td>
              <td><span className="mono">{part.identification?.sil_part_code}</span>{part.identification?.description ? ` — ${part.identification.description}` : ''}</td>
              <td>{part.identification?.size_thread}</td>
              <td>{part.identification?.material_grade}</td>
              <td>{part.identification?.order_qty}</td>
              <td>{date(part.identification?.delivery_date)}</td>
              <td className="mono">{part.part_sheet_no}</td>
              <td>{part.feasible === 'yes' ? 'Y' : part.feasible === 'no' ? 'N' : part.feasible === 'conditions' ? 'Y*' : ''}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2>3. Order-level review <span style={{ fontWeight: 400, textTransform: 'none' }}>— Marketing / Sales</span></h2>
      <Checklist items={sheet.order_review || []} />
      <Footer page={1} pages={pages} />

      {parts.map((part, index) => (
        <PartSheet key={part.id} part={part} index={index} total={parts.length} sheet={sheet} page={index + 2} pages={pages} />
      ))}

      <div className="page-break">
        <Header sheet={sheet} page={pages} pages={pages} />
        <h2>4. Order schedule</h2>
        <p className="hint">Consolidated from all Part Review Sheets</p>
        <table className="kv">
          <tbody>
            <tr>
              <td className="k">Earliest dispatch (first part)</td><td>{date(sheet.order_schedule?.earliest_dispatch)}</td>
              <td className="k">Committed delivery date(s)</td><td>{sheet.order_schedule?.committed_delivery ? date(sheet.order_schedule.committed_delivery) : ''}</td>
              <td className="k">Final dispatch (last part)</td><td>{date(sheet.order_schedule?.final_dispatch)}</td>
            </tr>
          </tbody>
        </table>

        <h2>5. Review outcome</h2>
        <table className="kv">
          <tbody>
            <tr><td className="k">Outcome</td><td colSpan={5} className="mark">
              {box(sheet.outcome?.result === 'accepted')} Order Accepted &nbsp;
              {box(sheet.outcome?.result === 'accepted_with_conditions')} Accepted with Conditions &nbsp;
              {box(sheet.outcome?.result === 'not_feasible')} Not Feasible — Customer to be informed
            </td></tr>
            <tr><td className="k">Conditions / deviations / remarks</td><td colSpan={5} style={{ height: '34px' }}>{sheet.outcome?.remarks}</td></tr>
          </tbody>
        </table>

        <h2>6. Review &amp; approval</h2>
        <table className="sign">
          <thead><tr><th style={{ width: '18%' }}>Function</th><th style={{ width: '28%' }}>Responsibility</th><th style={{ width: '22%' }}>Name</th><th>Signature</th><th style={{ width: '14%' }}>Date</th></tr></thead>
          <tbody>
            {(sheet.approvals || []).map((row) => (
              <tr key={row.id}>
                <td>{row.function}</td><td>{row.responsibility}</td><td>{row.name}</td><td /><td>{date(row.date)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p className="hint" style={{ marginTop: '8px' }}>
          This sheet, together with all Part Review Sheets, forms part of the order file along with the Customer PO,
          Order Acceptance and drawings / specifications. Retain for the period defined in the Records Control Procedure.
        </p>
        <Footer page={pages} pages={pages} />
      </div>
    </div>
  );
}
